const SITE_URL = "https://premierelens.com";

export function buildArchiveSeoMeta({ noindex = false } = {}) {
  return {
    title: "TV Show Premiere Archive | PremiereLens",
    description:
      "Explore the full TV premiere archive with semantic search by taste, mood, or setup. Browse curated shows by month with rating trends and genre analytics.",
    pathname: "/archive",
    canonicalUrl: `${SITE_URL}/archive`,
    ogUrl: `${SITE_URL}/archive`,
    image: `${SITE_URL}/og-image.jpg`,
    robots: noindex ? "noindex,follow" : "index,follow",
    ogType: "website",
  };
}
